/**
 * @generated SignedSource<<b0b8dad117abe486d85abce259972734>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type licenseDetails_RefetchQuery$variables = {
  licenseGroupingId: string;
};
export type licenseDetails_RefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"licenseDetails_LicenseGroupingFragment">;
};
export type licenseDetails_RefetchQuery = {
  response: licenseDetails_RefetchQuery$data;
  variables: licenseDetails_RefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "licenseGroupingId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "licenseGroupingId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "ContractPartner",
  "kind": "LinkedField",
  "name": "contractPartner",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContractPartnerData",
      "kind": "LinkedField",
      "name": "data",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "linkToAGB",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v2/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbnail",
      "storageKey": null
    },
    (v2/*: any*/)
  ],
  "storageKey": null
},
v9 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "CoachingOfferDescription",
    "kind": "LinkedField",
    "name": "description",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "storageKey": null
  }
],
v10 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LearnOpportunityV2",
    "kind": "LinkedField",
    "name": "root",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      (v6/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "structureDefinition",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "extension",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "extension",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/)
                            ],
                            "type": "PublishedConstellationRootExtensionExtension",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "PublishedRootExtensionImpl",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "LearnOpportunityRootStructureDefinition",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      (v8/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "licenseDetails_RefetchQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "licenseGroupingId",
            "variableName": "licenseGroupingId"
          }
        ],
        "kind": "FragmentSpread",
        "name": "licenseDetails_LicenseGroupingFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "licenseDetails_RefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "LicenseGroupingQueries",
        "kind": "LinkedField",
        "name": "LicenseGrouping",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "licenseGroupingId"
              }
            ],
            "concreteType": null,
            "kind": "LinkedField",
            "name": "LicenseGrouping",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "usedLicenseAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalLicenseAmount",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isLicenseGrouping"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "assignmentRules",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "active",
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "accountRef",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "amountEffectedUser",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserInAccountGroup",
                        "kind": "LinkedField",
                        "name": "userInAccountGroups",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isBuiltIn",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "AccountGroupAssignmentRule",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "userId",
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "licensesUsedByUser",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "maxLicenseAmount",
                        "storageKey": null
                      }
                    ],
                    "type": "SingleUserAssignmentRule",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "learnable",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v3/*: any*/),
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CoachingOffer",
                            "kind": "LinkedField",
                            "name": "groupCoaching",
                            "plural": false,
                            "selections": (v9/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "PublishedGroupCoachingLearnable",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CoachingOffer",
                            "kind": "LinkedField",
                            "name": "oneToOneCoaching",
                            "plural": false,
                            "selections": (v9/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "PublishedOneToOneCoachingLearnable",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v10/*: any*/),
                        "type": "PublishedCourseLearnable",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v10/*: any*/),
                        "type": "PublishedMicroLearningLearnable",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "LearnableLicenseGrouping",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "55c397eb348a02f0ed2713c1b106210e",
    "id": null,
    "metadata": {},
    "name": "licenseDetails_RefetchQuery",
    "operationKind": "query",
    "text": "query licenseDetails_RefetchQuery(\n  $licenseGroupingId: ID!\n) {\n  ...licenseDetails_LicenseGroupingFragment_2p8GkE\n}\n\nfragment groupRulesTab_QueryFragment on AccountGroupAssignmentRule {\n  id\n}\n\nfragment licenseDetails_LicenseGroupingFragment_2p8GkE on Query {\n  LicenseGrouping {\n    LicenseGrouping(id: $licenseGroupingId) {\n      __typename\n      id\n      usedLicenseAmount\n      totalLicenseAmount\n      kind\n      ... on LearnableLicenseGrouping {\n        learnable {\n          __typename\n          kind\n          ... on PublishedGroupCoachingLearnable {\n            id\n            groupCoaching {\n              id\n              description {\n                name\n                description\n              }\n            }\n          }\n          ... on PublishedOneToOneCoachingLearnable {\n            id\n            oneToOneCoaching {\n              id\n              description {\n                name\n                description\n              }\n            }\n          }\n          ... on PublishedCourseLearnable {\n            id\n            root {\n              id\n              description\n              structureDefinition {\n                __typename\n                title\n              }\n            }\n          }\n          ... on PublishedMicroLearningLearnable {\n            id\n            root {\n              id\n              description\n              structureDefinition {\n                __typename\n                title\n              }\n            }\n          }\n          id\n        }\n      }\n      ...licensesProductCard_QueryFragment\n      assignmentRules {\n        __typename\n        ...licensesAccountGroupAssignmentCard_QueryFragment\n        ...licensesSingleUserAssignmentCard_SingleUserAssignmentRuleFragment\n        ...userRulesTab_QueryFragment\n        ...groupRulesTab_QueryFragment\n        id\n      }\n    }\n  }\n}\n\nfragment licensesAccountGroupAssignmentCard_QueryFragment on AccountGroupAssignmentRule {\n  __typename\n  id\n  name\n  active\n  licenseGroupingId\n  accountRef\n  amountEffectedUser\n  userInAccountGroups {\n    id\n    name\n    isBuiltIn\n  }\n}\n\nfragment licensesProductCard_QueryFragment on LicenseGrouping {\n  __isLicenseGrouping: __typename\n  kind\n  ... on LearnableLicenseGrouping {\n    learnable {\n      __typename\n      ... on PublishedGroupCoachingLearnable {\n        groupCoaching {\n          id\n          description {\n            contractPartner {\n              data {\n                name\n                linkToAGB\n              }\n              id\n            }\n            name\n            image {\n              thumbnail\n              id\n            }\n          }\n        }\n      }\n      ... on PublishedOneToOneCoachingLearnable {\n        oneToOneCoaching {\n          id\n          description {\n            contractPartner {\n              data {\n                name\n                linkToAGB\n              }\n              id\n            }\n            name\n            image {\n              thumbnail\n              id\n            }\n          }\n        }\n      }\n      ... on PublishedCourseLearnable {\n        id\n        root {\n          id\n          description\n          image {\n            thumbnail\n            id\n          }\n          structureDefinition {\n            __typename\n            title\n            ... on LearnOpportunityRootStructureDefinition {\n              extension {\n                __typename\n                ... on PublishedRootExtensionImpl {\n                  extension {\n                    __typename\n                    ... on PublishedConstellationRootExtensionExtension {\n                      contractPartner {\n                        data {\n                          name\n                          linkToAGB\n                        }\n                        id\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      ... on PublishedMicroLearningLearnable {\n        id\n        root {\n          id\n          description\n          image {\n            thumbnail\n            id\n          }\n          structureDefinition {\n            __typename\n            title\n            ... on LearnOpportunityRootStructureDefinition {\n              extension {\n                __typename\n                ... on PublishedRootExtensionImpl {\n                  extension {\n                    __typename\n                    ... on PublishedConstellationRootExtensionExtension {\n                      contractPartner {\n                        data {\n                          name\n                          linkToAGB\n                        }\n                        id\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment licensesSingleUserAssignmentCard_SingleUserAssignmentRuleFragment on SingleUserAssignmentRule {\n  __typename\n  id\n  userId\n  licenseGroupingId\n  licensesUsedByUser\n  maxLicenseAmount\n}\n\nfragment userRulesTab_QueryFragment on SingleUserAssignmentRule {\n  id\n  userId\n  licensesUsedByUser\n  maxLicenseAmount\n}\n"
  }
};
})();

(node as any).hash = "969aefa155af13ee333603a6ff3c9066";

export default node;
